import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import { compose } from "redux";
import { firebaseConnect } from "react-redux-firebase";
import { withTranslation } from "react-i18next";
import * as actions from "../../actions/accountModalActions";

import {
  VIEW_CHANGE_EMAIL,
  VIEW_CREATE_ACCOUNT,
  VIEW_DELETE_ACCOUNT,
  VIEW_EDIT_PROFILE,
  VIEW_FORGOT_PASSWORD,
  VIEW_LOGIN
} from "../../constants/accountModalConstants";
import CaAccountFormContainer from "./CaAccountFormContainer";
import CaAccountLoginContainer from "./CaAccountLoginContainer";
import CaAccountCreateAccountContainer from "./CaAccountCreateAccountContainer";
import CaAccountForgotPasswordContainer from "./CaAccountForgotPasswordContainer";
import CaAccountUpdateProfileContainer from "./CaAccountUpdateProfileContainer";
import CaAccountDeleteAccountContainer from "./CaAccountDeleteAccountContainer";
import CaAccountChangeEmailContainer from "./CaAccountChangeEmailContainer";

class CaAccountModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };

    this.handleEscKey = this.handleEscKey.bind(this);
    this.clickOnBg = this.clickOnBg.bind(this);
    this.newsletterSignUp = this.newsletterSignUp.bind(this);
  }

  clickOnBg(e) {
    const { close } = this.props;
    if (e.target == e.currentTarget) {
      this.setState({
        loading: false,
        errorMessage: "",
        successMessage: ""
      });
      close();
    }
  }
  handleEscKey(e) {
    const { close } = this.props;
    if (e.keyCode == 27) {
      this.setState({
        loading: false,
        errorMessage: "",
        successMessage: ""
      });
      close();
    }
  }

  componentWillMount() {
    window.addEventListener("keydown", this.handleEscKey, false);
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleEscKey, false);
  }

  componentDidMount() {
    document.body.classList.add("quiz-active");
  }

  createAccount(data) {
    const { close, firebase } = this.props;
    const email = this.getField(data, "create_email");
    const password = this.getField(data, "create_password");
    const name = this.getField(data, "create_name");
    const lastname = this.getField(data, "create_lastname");
    const country = this.getField(data, "create_country");

    this.setState({
      loading: true,
      errorMessage: "",
      successMessage: ""
    });

    let authPromise = null;

    if (
      firebase.auth().currentUser &&
      firebase.auth().currentUser.isAnonymous
    ) {
      // Just update anonymous user
      var credential = firebase.auth.EmailAuthProvider.credential(
        email,
        password
      );
      firebase.updateProfile({
        name: name,
        lastname: lastname,
        country: country
      });
      authPromise = firebase
        .auth()
        .currentUser.linkAndRetrieveDataWithCredential(credential);
    } else {
      authPromise = firebase.createUser(
        {
          email: email,
          password: password
        },
        {
          name: name,
          lastname: lastname,
          country: country
        }
      );
    }

    authPromise
      .then(res => {
        this.setState({
          loading: false,
          successMessage: this.props.t(
            "account_modal.create_account.success_message"
          )
        });
        const formData = new FormData();
        formData.append("country", country);
        formData.append("action", "abba_signup");
        formData.append("firstName", name);
        formData.append("email", email);
        this.newsletterSignUp(formData)
          .then(response => {
            console.log(response);
            window.location.href = "/profile";
          })
          .catch(e => {
            console.log(e);
            window.location.href = "/profile";
          });
      })
      .catch(err => {
        console.log(err);
        this.setState({
          loading: false,
          errorMessage: err.message
        });
      });
  }

  newsletterSignUp(newsletterData) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: ajax_object.ajax_url,
        data: newsletterData
      })
        .then(response => {
          resolve(response);
        })
        .catch(e => {
          reject(e);
        });
    });
  }

  forgotPassword(data) {
    const { close, firebase } = this.props;
    const email = this.getField(data, "forgot_email");

    this.setState({
      loading: true,
      errorMessage: "",
      successMessage: ""
    });

    firebase
      .resetPassword(email)
      .then(res => {
        this.setState({
          successMessage: this.props.t(
            "account_modal.forgot_password.success_message"
          ),
          loading: false
        });
        //close();
      })
      .catch(err => {
        console.log(err);
        this.setState({
          loading: false,
          errorMessage: err.message
        });
      });
  }
  login(data) {
    const { close, firebase } = this.props;
    const email = this.getField(data, "login_email");
    const password = this.getField(data, "login_password");
    // console.log(email,password);

    this.setState({
      loading: true,
      errorMessage: "",
      successMessage: ""
    });

    firebase
      .login({
        email: email,
        password: password
      })
      .then(res => {
        // console.log("Logged in",res);
        this.setState({ loading: false });
        close();
      })
      .catch(err => {
        // console.log(err);
        this.setState({
          loading: false,
          errorMessage: err.message
        });
      });
  }

  editProfile(data) {
    const { close, firebase } = this.props;
    const name = this.getField(data, "update_name");
    const lastname = this.getField(data, "update_lastname");
    const country = this.getField(data, "update_country");
    // console.log(name,lastname,country);

    this.setState({
      loading: true,
      errorMessage: "",
      successMessage: ""
    });

    firebase
      .updateProfile({
        name: name,
        lastname: lastname,
        country: country
      })
      .then(res => {
        this.setState({
          successMessage: this.props.t(
            "account_modal.update_profile.success_message"
          ),
          loading: false
        });
      })
      .catch(err => {
        console.log(err);
        this.setState({
          loading: false,
          errorMessage: err.message
        });
      });
  }

  deleteAccount(data) {
    const { close, firebase } = this.props;
    const password = this.getField(data, "delete_password");
    // console.log(password,firebase);

    this.setState({
      loading: true,
      errorMessage: "",
      successMessage: ""
    });

    const user = firebase.auth().currentUser;

    firebase
      .login({
        email: user.email,
        password: password
      })
      .then(res => {
        // console.log("Re-logged in");
        const user = firebase.auth().currentUser;
        // console.log(user);
        const userId = user.uid;
        user
          .delete()
          .then(() => {
            firebase
              .database()
              .ref("users/" + userId)
              .remove()
              .then(res => {
                // console.log("PROFILE DELETED");

                firebase
                  .logout()
                  .then(res => {})
                  .catch(res => {
                    console.log(res);
                  });
                window.alert(
                  this.props.t("account_modal.delete_account.success_message")
                );

                this.setState({
                  loading: false
                });

                //close();
              })
              .catch(err => {
                console.log(err);
                this.setState({
                  loading: false,
                  errorMessage: err.message
                });
              });
          })
          .catch(err => {
            console.log(err);
            this.setState({
              loading: false,
              errorMessage: err.message
            });
          });
      })
      .catch(err => {
        console.log(err);
        this.setState({
          loading: false,
          errorMessage: err.message
        });
      });
  }

  changeEmail(data) {
    const { close, firebase } = this.props;
    const email = this.getField(data, "change_email");
    const password = this.getField(data, "change_password");
    // console.log(email, password);

    this.setState({
      loading: true,
      errorMessage: "",
      successMessage: ""
    });

    const user = firebase.auth().currentUser;

    firebase
      .login({
        email: user.email,
        password: password
      })
      .then(res => {
        // console.log("Re-logged in");
        user
          .updateEmail(email)
          .then(() => {
            // console.log("Email changed");

            firebase
              .logout()
              .then(res => {
                /*console.log("Logged out")*/
              })
              .catch(res => {
                console.log(res);
              });
            close();

            window.alert(
              this.props.t("account_modal.change_email.success_message")
            );

            this.setState({
              loading: false
            });
          })
          .catch(err => {
            console.log(err);
            this.setState({
              loading: false,
              errorMessage: err.message
            });
          });
      })
      .catch(err => {
        console.log(err);
        this.setState({
          loading: false,
          errorMessage: err.message
        });
      });
  }
  resetPassword() {
    const { close, firebase } = this.props;

    this.setState({
      loading: true,
      errorMessage: "",
      successMessage: ""
    });
    const user = firebase.auth().currentUser;
    firebase
      .resetPassword(user.email)
      .then(res => {
        firebase
          .logout()
          .then(res => {
            /*console.log("Logged out")*/
          })
          .catch(res => {
            console.log(res);
          });
        close();
        this.setState({
          loading: false
        });
        window.alert(
          this.props.t("account_modal.reset_password.success_message")
        );
      })
      .catch(err => {
        console.log(err);
        this.setState({
          loading: false,
          errorMessage: err.message
        });
      });
  }

  getField(data, id) {
    const ids = data.map(item => item.id);
    return data[ids.indexOf(id)].ref.value;
  }

  getContent() {
    const { quiz, close, changeView } = this.props;
    const { loading } = this.state;
    let { errorMessage, successMessage } = this.state;

    const { view } = quiz.accountModalReducer;

    if (this.prevView != view) {
      //I know.. not correct. :/ Sorry!
      errorMessage = this.state.errorMessage = "";
      successMessage = this.state.successMessage = "";
    }
    this.prevView = view;

    const data = {
      iconsBasePath: this.props.iconsBasePath,
      onSubmit: data => this.login(data),
      onClose: () => close(),
      onNavigate: view => changeView(view),
      errorMessage: errorMessage,
      successMessage: successMessage,
      loading: loading
    };

    switch (view) {
      case VIEW_LOGIN:
        return (
          <CaAccountFormContainer
            {...Object.assign({}, data, {
              key: 0,
              FormViewContainer: CaAccountLoginContainer,
              onSubmit: data => this.login(data)
            })}
          />
        );
      case VIEW_CREATE_ACCOUNT:
        return (
          <CaAccountFormContainer
            {...Object.assign({}, data, {
              key: 1,
              FormViewContainer: CaAccountCreateAccountContainer,
              onSubmit: data => this.createAccount(data)
            })}
          />
        );
      case VIEW_FORGOT_PASSWORD:
        return (
          <CaAccountFormContainer
            {...Object.assign({}, data, {
              key: 2,
              FormViewContainer: CaAccountForgotPasswordContainer,
              onSubmit: data => this.forgotPassword(data)
            })}
          />
        );
      case VIEW_EDIT_PROFILE:
        return (
          <CaAccountFormContainer
            {...Object.assign({}, data, {
              key: 3,
              FormViewContainer: CaAccountUpdateProfileContainer,
              onSubmit: data => this.editProfile(data)
            })}
          />
        );
      case VIEW_DELETE_ACCOUNT:
        return (
          <CaAccountFormContainer
            {...Object.assign({}, data, {
              key: 4,
              FormViewContainer: CaAccountDeleteAccountContainer,
              onSubmit: data => this.deleteAccount(data)
            })}
          />
        );
      case VIEW_CHANGE_EMAIL:
        return (
          <CaAccountFormContainer
            {...Object.assign({}, data, {
              key: 5,
              FormViewContainer: CaAccountChangeEmailContainer,
              onSubmit: data => this.changeEmail(data)
            })}
          />
        );
    }
  }

  render() {
    const { quiz } = this.props;
    const { open } = quiz.accountModalReducer;
    const { loading } = this.state;

    if (!open) return <div />;

    return (
      <div
        onClick={this.clickOnBg}
        className={"AccountModal" + (loading ? " AccountModal--loading" : "")}
      >
        {this.getContent()}
      </div>
    );
  }
}

export default compose(
  connect(
    state => ({
      auth: state.firebase.auth,
      quiz: state,
      profile: state.firebase.profile
    }),
    actions
  ),
  firebaseConnect()
)(withTranslation("translations")(CaAccountModal));
